import Swiper from 'swiper/bundle';

(function ($) {

    //swiper
    let swiper = new Swiper(".section-with-articles .slider-articles", {
        slidesPerView: 'auto',
        spaceBetween: 8,
        centeredSlides: false,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        navigation: {
            nextEl: ".section-with-articles .swiper-button-next",
            prevEl: ".section-with-articles .swiper-button-prev",
        },
        pagination: {
            el: ".section-with-articles .swiper-pagination",
            clickable: true,
        }
    });

//play video preview on hover
    $(document).ready(function() {
        const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

        $('.section-with-articles .wrap-video video').each(function() {
            const $video = $(this);

            if (isTouchDevice) {
                //$video.removeAttr('autoplay');
            } else {
                $video.removeAttr('autoplay');
                const $wrapVideo = $video.closest('.wrap-video');

                $wrapVideo.on('mouseenter', function() {
                    $video.get(0).play();
                });

                $wrapVideo.on('mouseleave', function() {
                    $video.get(0).pause();
                    //$video.get(0).currentTime = 0; //start video from 0
                });
            }
        });
    });


})(jQuery);